<template>
  <div>
    <div class="card">
      <div class="col-md-7">
        <div class="form-group m-label-left">
          <input type="text" id="editNameModel" class="form-control" rows="3" v-model="model" />
          <label for="editNameModel">Model</label>
        </div>

        <div class="form-group m-label-left">
          <textarea
            id="editNameDesc"
            class="form-control"
            rows="16"
            v-model="description"
          ></textarea>
          <label for="editNameDesc">Description</label>
        </div>

        <div class="form-group m-label-left">
          <input id="editNametemp" type="text" class="form-control" v-model="temperature" />
          <label for="editNametemp">Temperature</label>
        </div>

        <div class="form-group m-label-left">
          <select class="form-select" v-model="engine">
            <option value="gpt-5.6">gpt-5.6 Sol</option>
            <option value="gpt-5.6-terra">gpt-5.6 Terra</option>
            <option value="gpt-5.6-luna">gpt-5.6 Luna</option>
            <option value="gpt-5.5">gpt-5.5</option>
            <option value="gpt-5.4">gpt-5.4</option>
            <option value="gpt-5.4-mini">gpt-5.4 mini</option>
            <option value="gpt-5">gpt-5</option>
            <option value="gpt-5-nano">gpt-5 nano</option>
            <option value="gpt-4o">gpt-4o</option>
            <option value="gpt-4-turbo">gpt-4 turbo</option>
          </select>
          <label for="editNameDesc">Engine</label>
        </div>
        <div class="d-flex">
          <button :disabled="isLoading" @click="addModel" class="btn btn-primary ml-auto mr-2">
            Save
          </button>
          <button @click="cancelTitle" class="btn btn-secondary mr-2">Cancel</button>
        </div>
      </div>
    </div>
    <Spinner :isLoading="isLoading" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import axios from 'axios';
import titleMixin from '../../../mixins/titleMixin';

export default {
  mixins: [titleMixin],
  title() {
    return 'AI Models | Jobshark';
  },
  /*   description() {
      return 'Page description goes here.';
    }, */
  canonicalLink() {
    return 'https://jobshark.eu/admin/campaigns';
  },
  props: {
    itemToEdit: Object,
  },
  components: {},
  data: () => ({
    isLoading: false,
    model: '',
    description: '',
    temperature: '',
    engine: '',
  }),
  methods: {
    addModel() {
      this.isLoading = true;
      if (this.itemToEdit === null) {
        axios(`${process.env.VUE_APP_API_URL}/admin/chatgpt/createmodel`, {
          method: 'post',
          data: {
            model: this.model,
            description: this.description,
            temperature: this.temperature,
            engine: this.engine,
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem(
              `${process.env.VUE_APP_TOKEN_PREFIX}token`,
            )}`,
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        }).then(res => {
          this.$toasted.success('AI model added', {
            theme: 'bubble',
            icon: 'fa-times-circle',
            position: 'bottom-right',
            duration: 8000,
          });
          this.cancelTitle();
        });
      } else {
        this.editModel();
      }
    },
    editModel() {
      axios(`${process.env.VUE_APP_API_URL}/admin/chatgpt/updatemodel`, {
        method: 'post',
        data: {
          model_id: this.itemToEdit.id,
          model: this.model,
          description: this.description,
          temperature: this.temperature,
          engine: this.engine,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            `${process.env.VUE_APP_TOKEN_PREFIX}token`,
          )}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      }).then(res => {
        this.cancelTitle();
        this.$toasted.success('AI model updated', {
          theme: 'bubble',
          icon: 'fa-times-circle',
          position: 'bottom-right',
          duration: 8000,
        });
      });
    },
    cancelTitle() {
      this.$emit('cancel');
      this.model = '';
      this.description = '';
      this.temperature = '';
      this.engine = '';
      this.isLoading = false;
    },
  },
  computed: {
    ...mapGetters(['getUserProfile']),
  },
  mounted() {
    if (this.itemToEdit !== null) {
      (this.model = this.itemToEdit.model),
        (this.description = this.itemToEdit.description),
        (this.temperature = this.itemToEdit.temperature),
        (this.engine = this.itemToEdit.engine);
    }
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';

.col-md-7 {
  padding-top: 30px;
  padding-bottom: 30px;
}

.controls {
  font-family: $font-family-sans-lato;
  padding: 1rem;
  .input-group {
    width: 35%;
    position: relative;
    i {
      color: #a7a7a7;
      position: absolute;
      pointer-events: none;
      top: 8px;
      right: 12px;
      font-size: 21px;
      z-index: 99;
    }
    .form-control {
      border-radius: 4px !important;
    }
  }
  .btn-outline-success {
    border-color: #ced4da;
  }
}
.modal-body {
  .form-control {
    padding: 6px 12px !important;
    height: 42px !important;
  }
  .btn-outline-success {
    height: 40px;
  }
  .custom-checkbox {
    margin: 20px 0 5px 0;
  }
}

.edit-modal {
  .modal-body {
    .text-center {
      margin-bottom: 20px;
      i {
        font-size: 51px;
        display: block;
        margin: 20px auto 30px auto;
      }
      .btn-success {
        font-size: 13px;
      }
    }
    .list-unstyled {
      li {
        margin-bottom: 6px;
        padding-bottom: 6px;
        border-bottom: 1px dashed #ddd;
        font-size: 14px;
        span {
          float: right;
        }
      }
    }
  }
}
.table-container {
  padding: 1rem;
  .table {
    a {
      text-decoration: none;
    }
    thead {
      color: #222;
      font-size: 13px;
      font-weight: 700;
      text-transform: uppercase;
      th {
        vertical-align: middle;
        i {
          font-size: 31px;
          margin-right: 12px;
        }
        .fas {
          font-size: 14px;
          color: #666;
          transition: all 0.3s ease-in-out;
          -moz-transition: all 0.3s ease-in-out;
          -webkit-transition: all 0.3s ease-in-out;
        }
        &:last-of-type {
          a {
            margin-left: 12px;
            color: #666;
            i {
              font-size: 16px;
            }
          }
        }
        .is-open {
          .fas {
            -ms-transform: rotate(90deg); /* IE 9 */
            transform: rotate(90deg); /* Standard syntax */
          }
        }
      }
    }
    tbody {
      tr {
        th {
          font-weight: 400;
          font-size: 14px;
          i {
            font-size: 28px;
            margin-right: 18px;
          }
        }
        td {
          font-size: 14px;
          vertical-align: middle;
          font-family: $font-family-sans-lato;
          &:last-of-type {
            text-align: right;
            padding-right: 23px;
            a {
              color: #666;
              margin-left: 28px;
              i {
                font-size: 16px;
              }
            }
          }
        }
      }
    }
  }
}

.isDisabled {
  color: currentColor;
  cursor: not-allowed;
  opacity: 0.5;
  text-decoration: none;
}

.fa-exchange-alt {
  -ms-transform: rotate(90deg); /* IE 9 */
  transform: rotate(90deg); /* Standard syntax */
}
</style>
